import Spline from './Spline';

export default Spline;
